import styled, { css } from "styled-components";
import { BaseGridContainer } from "../../utils/styles";

export const ProductsWrap = styled(BaseGridContainer)`
	margin: 0 auto 12px auto;
`;
export interface GridMoreBaseBoxProps {
	gridCol: number;
	gridGap: number;
	width: number | string;
}
export const GridMoreBaseBox = styled.section.withConfig({
	shouldForwardProp: (prop) => !["gridCol", "gridGap", "width"].includes(prop),
})<GridMoreBaseBoxProps>`
	width: inherit;
	margin: 0 auto;
	display: grid;
	grid-template-areas: "a a .";
	flex-wrap: wrap;

	${(props: GridMoreBaseBoxProps) => {
		const gap = props.gridGap || 12;
		if (typeof props.width === "number") {
			return css`
				grid-gap: ${gap}px;
				grid-template-columns: repeat(auto-fill, ${props.width}px);
			`;
		}
		return css`
			grid-gap: ${gap}px;
			width: ${props.width};
		`;
	}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;
		${(props: GridMoreBaseBoxProps) => {
			const gridCol = props.gridCol || 4;
			const gap = props.gridGap || 12;
			return css`
				margin-right: ${gap}px;
				&:nth-child(${gridCol}n + 1),
				&:first-child {
					margin-right: 0;
				}
			`;
		}}
	}
`;

export const GridRowOneBox = styled.section.withConfig({
	shouldForwardProp: (prop) => !["gridCol", "gridGap", "width"].includes(prop),
})<GridMoreBaseBoxProps>`
	width: inherit;
	margin: 0 auto;
	display: flex;
	flex-wrap: wrap;

	${(props: GridMoreBaseBoxProps) => {
		const gap = props.gridGap || 12;
		return css`
			margin-top: ${gap}px;
			grid-gap: ${gap}px;
		`;
	}}

	@supports not (grid-gap: 12px) {
		&:after {
			content: "";
			clear: both;
			height: 0;
			width: 0;
			visibility: hidden;
			display: block;
		}
		${(props: GridMoreBaseBoxProps) => {
			const gridCol = props.gridCol || 4;
			return css`
				&:nth-child(${gridCol}n + 1),
				&:first-child {
					margin-right: ${props.gridGap}px;
				}
			`;
		}}
	}
`;

export const ProductCardWrap = styled.section`
	> a {
		width: 100%;
		height: 100%;
	}
`;
